<ng-template #content>
  <div class="mtg-menu {{ class }}">
    <ng-content></ng-content>
  </div>
</ng-template>
